<div
  class="attachments"
  [class.is-mobile]="isMobile"
  *ngIf="attachments.length"
>
  <div
    class="card"
    [class.invalid]="isAttachmentInvalid(attachment)"
    *ngFor="let attachment of attachments"
  >
    @if (isAttachmentInvalid(attachment)) {
      <div class="error-container">
        <ly-icon
          class="error-icon mb-1"
          icon="error"
          type="negative"
          size="18px"
        />
        <span class="error-filename">{{
          getAttachmentErrorFileName(attachment)
        }}</span>

        <span class="error-message">{{
          getAttachmentErrorMessage(attachment)
        }}</span>

        <button
          class="button indigo outlined fluid"
          (click)="onDelete(attachment)"
        >
          Remove
        </button>
      </div>
    } @else {
      @if (!isAttachmentUsedInPost(attachment)) {
        <ly-icon
          class="icon delete"
          (click)="onDelete(attachment)"
          *ngIf="!disabled"
          size="18px"
          icon="close"
        ></ly-icon>
      } @else {
        <ly-icon
          class="icon delete"
          *ngIf="!disabled"
          lyConfirm
          [lyConfirmTitle]="'Delete media from active posts'"
          [lyConfirmContent]="
            'Heads up! This will delete the media from all active posts. Want to go ahead?'
          "
          [lyConfirmBtnLabel]="'Yes, delete it'"
          [lyConfirmHasRejectBtn]="true"
          [lyConfirmRejectBtnLabel]="'No, keep as is'"
          (confirm)="onDelete(attachment)"
          size="18px"
          icon="close"
        ></ly-icon>
      }

      <div class="attachment-details">
        <ly-icon
          [icon]="attachment.type === MEDIA_TYPE.image ? 'image' : 'video'"
        />
        <strong>{{ attachment.name }}</strong>
        <span> {{ attachment.width }} x {{ attachment.height }}px</span>
      </div>
      <div class="attachment">
        @if (attachment.type === MEDIA_TYPE.image) {
          <img [src]="attachment.thumbnailURL" />
        }

        @if (attachment.type === MEDIA_TYPE.video) {
          <video [src]="attachment.URL"></video>
        }

        <ly-icon
          *ngIf="attachment.type === MEDIA_TYPE.video"
          class="icon video"
          size="44px"
          icon="video"
        ></ly-icon>
      </div>
    }
  </div>
</div>
